import { render, staticRenderFns } from "./ObserverIntersect.vue?vue&type=template&id=97b8ea3e&"
import script from "./ObserverIntersect.vue?vue&type=script&lang=js&"
export * from "./ObserverIntersect.vue?vue&type=script&lang=js&"
import style0 from "./ObserverIntersect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports